import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faPen } from "@fortawesome/free-solid-svg-icons";
import isCaseTerminated from "../../../common/helpers/isCaseTerminated";
import { normalizeDateTime } from "../../../common/helpers/normalizeDateTime";
import { Grid } from "@mui/material";
import { StyledBanner } from "../../../common/components/BannerTitle/styles";
import BannerInfo from "../../../common/components/BannerInfo";
import UpdatePatientDialog from "./UpdatePatientDialog";
import { StyledH2 } from "../../../common/components/Title/styles";
import {
  StyledText,
  StyledLink,
} from "../../../common/components/Title/styles";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import EditDentistDialog from "./EditDentistDialog";
import { StyledButton } from "../../../common/components/Button";
import { grey } from "@mui/material/colors";
const CaseDetailsDashboard = ({
  caseDetails,
  isFromManageAlina,
  onDentistUpdate,
  isSubmittingDentist,
  fetchCase,
}) => {
  const navigate = useNavigate();
  const [isEditDentistOpen, setEditDentistOpen] = useState(false);
  const [openUpdatePatient, setOpenUpdatePatient] = useState(false);

  const handleCloseUpdatePatient = () => {
    setOpenUpdatePatient(false);
  };

  const user = useSelector((state) => state.user);

  const handleEditDentistClick = () => {
    setEditDentistOpen(true);
  };

  const handleEditDentistClose = () => {
    setEditDentistOpen(false);
  };

  return (
    <StyledBanner theme="purple">
      <UpdatePatientDialog
        openUpdatePatient={openUpdatePatient}
        handleCloseUpdatePatient={handleCloseUpdatePatient}
        caseDetails={caseDetails}
        fetchCase={fetchCase}
      />
      <StyledLink
        style={{
          paddingTop: "20px",
          cursor: "pointer",
          fontSize: "13px",
        }}
        theme="purple"
        onClick={() => navigate("/cases")}
      >
        <FontAwesomeIcon
          style={{ fontSize: "19px", paddingRight: "12px" }}
          icon={faAngleLeft}
          FontAwesomeIcon
        />
        Back to Cases
      </StyledLink>

      <StyledH2 theme="green" style={{ margin: 0 }}>
        Case # {caseDetails.caseNo}
      </StyledH2>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          padding: "15px 0",
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <BannerInfo
              stlye={{
                display: "flex",
                flexDirection: "column",
                paddingRight: "20px",
              }}
            >
              <Grid container spacing={1} style={{ marginBottom: "6px" }}>
                <Grid
                  item
                  xs={6}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <StyledText
                    display="block"
                    width="full"
                    fontSize={14}
                    fontWeight={700}
                    borderRadius="100px"
                    theme="lightpurple"
                  >
                    <div style={{ color: "black" }}>Patient Information</div>
                  </StyledText>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  {caseDetails.status !== "Case complete" &&
                  !isCaseTerminated(caseDetails) ? (
                    <StyledButton
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                      theme="green"
                      onClick={() => setOpenUpdatePatient(true)}
                    >
                      <FontAwesomeIcon
                        style={{
                          fontSize: "13px",
                          paddingRight: "8px",
                        }}
                        icon={faPen}
                        FontAwesomeIcon
                      />
                      Edit
                    </StyledButton>
                  ) : null}
                </Grid>
                <Grid item xs={12}>
                  <hr sx={{ height: "1px", border: 0 }} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
                >
                  <p
                    style={{
                      overflowWrap: "break-word",
                      color: grey[900],
                      fontWeight: 600,
                      fontSize: "25px",
                      margin: 0,
                    }}
                  >
                    {caseDetails.patientName}
                  </p>
                </Grid>
              </Grid>
              <Grid container spacing={0.5}>
                <Grid item xs={6}>
                  <StyledText
                    display="inline"
                    fontSize={13}
                    fontWeight={400}
                    theme="purple"
                    style={{
                      color: grey[700],
                    }}
                  >
                    Contact Number
                  </StyledText>
                </Grid>
                <Grid item xs={6}>
                  <StyledText
                    display="inline"
                    fontSize={14}
                    fontWeight={600}
                    theme="purple"
                  >
                    {caseDetails.patient.contactNumber}
                  </StyledText>
                </Grid>

                <Grid item xs={6}>
                  <StyledText
                    display="inline"
                    fontSize={13}
                    fontWeight={400}
                    theme="purple"
                    style={{
                      color: grey[700],
                    }}
                  >
                    Email
                  </StyledText>
                </Grid>
                <Grid item xs={6}>
                  <StyledText
                    display="block"
                    fontSize={14}
                    fontWeight={600}
                    theme="purple"
                    style={{
                      overflowWrap: "break-word",
                    }}
                    width="100%"
                  >
                    <div style={{ overflowWrap: "break-word" }}>
                      {caseDetails.patient.email}
                    </div>
                  </StyledText>
                </Grid>

                <Grid item xs={6}>
                  <StyledText
                    display="inline"
                    fontSize={13}
                    fontWeight={400}
                    theme="purple"
                    style={{
                      color: grey[700],
                    }}
                  >
                    Address
                  </StyledText>
                </Grid>
                <Grid item xs={6}>
                  <StyledText
                    display="inline"
                    fontSize={14}
                    fontWeight={600}
                    theme="purple"
                  >
                    <div
                      style={{
                        whiteSpace: "initial",
                      }}
                    >
                      {caseDetails.patient.address}
                    </div>
                  </StyledText>
                </Grid>

                {caseDetails.patient.dateOfBirth && (
                  <>
                    <Grid item xs={6}>
                      <StyledText
                        display="inline"
                        fontSize={13}
                        fontWeight={400}
                        theme="purple"
                        style={{
                          color: grey[700],
                        }}
                      >
                        Date of Birth
                      </StyledText>
                    </Grid>
                    <Grid item xs={6}>
                      <StyledText
                        display="inline"
                        fontSize={14}
                        fontWeight={600}
                        theme="purple"
                      >
                        {normalizeDateTime(caseDetails.patient.dateOfBirth)}
                      </StyledText>
                    </Grid>
                  </>
                )}

                {caseDetails.patient.sex && (
                  <>
                    <Grid item xs={6}>
                      <StyledText
                        display="inline"
                        fontSize={13}
                        fontWeight={400}
                        theme="purple"
                        style={{
                          color: grey[700],
                        }}
                      >
                        Sex
                      </StyledText>
                    </Grid>
                    <Grid item xs={6}>
                      <StyledText
                        display="inline"
                        fontSize={14}
                        fontWeight={600}
                        theme="purple"
                      >
                        {caseDetails.patient.sex}
                      </StyledText>
                    </Grid>
                  </>
                )}

                <Grid item xs={6}>
                  <StyledText
                    display="inline"
                    fontSize={13}
                    fontWeight={400}
                    theme="purple"
                    style={{
                      color: grey[700],
                    }}
                  >
                    Source
                  </StyledText>
                </Grid>
                <Grid item xs={6}>
                  <StyledText
                    display="inline"
                    fontSize={14}
                    fontWeight={600}
                    theme="purple"
                  >
                    {caseDetails.patient.source.name}
                  </StyledText>
                </Grid>
              </Grid>
            </BannerInfo>
          </Grid>

          <Grid item xs={6}>
            {user.roles.includes("Operations") && (
              <>
                {caseDetails.dentist && (
                  <>
                    <BannerInfo>
                      <Grid
                        container
                        spacing={1}
                        style={{ marginBottom: "6px" }}
                      >
                        <Grid
                          item
                          xs={6}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <StyledText
                            display="block"
                            width="full"
                            fontSize={14}
                            fontWeight={700}
                            borderRadius="100px"
                            theme="lightpurple"
                          >
                            <div style={{ color: "black" }}>
                              Dentist Information
                            </div>
                          </StyledText>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                          }}
                        >
                          {caseDetails.status !== "Case complete" &&
                          !isCaseTerminated(caseDetails) ? (
                            <StyledButton
                              style={{
                                cursor: "pointer",
                                fontSize: "14px",
                              }}
                              theme="green"
                              onClick={handleEditDentistClick}
                            >
                              <FontAwesomeIcon
                                style={{
                                  fontSize: "13px",
                                  paddingRight: "8px",
                                }}
                                icon={faPen}
                                FontAwesomeIcon
                              />
                              Edit
                            </StyledButton>
                          ) : null}
                        </Grid>
                        <Grid item xs={12}>
                          <hr
                            sx={{
                              backgroundColor: "red",
                              height: "1px",
                              border: 0,
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          style={{
                            paddingTop: "1rem",
                            paddingBottom: "1rem",
                          }}
                        >
                          <p
                            style={{
                              overflowWrap: "break-word",
                              color: grey[900],
                              fontWeight: 600,
                              fontSize: "25px",
                              margin: 0,
                            }}
                          >
                            {`${caseDetails.dentist.user.firstName} ${caseDetails.dentist.user.lastName}`}
                          </p>
                        </Grid>
                      </Grid>
                      <Grid container spacing={0.5}>
                        <Grid item xs={6}>
                          <StyledText
                            display="inline"
                            fontSize={13}
                            fontWeight={400}
                            color={grey[700]}
                            theme="purple"
                            style={{
                              color: grey[700],
                            }}
                          >
                            Dental Clinic Name
                          </StyledText>
                        </Grid>
                        <Grid item xs={6}>
                          <StyledText
                            display="inline"
                            fontSize={14}
                            fontWeight={600}
                            theme="purple"
                          >
                            {caseDetails.dentist.dentalClinic.name}
                          </StyledText>
                        </Grid>
                        <Grid item xs={6}>
                          <StyledText
                            display="inline"
                            fontSize={13}
                            fontWeight={400}
                            theme="purple"
                            style={{
                              color: grey[700],
                            }}
                          >
                            Email
                          </StyledText>
                        </Grid>
                        <Grid item xs={6}>
                          <StyledText
                            display="inline"
                            fontSize={14}
                            fontWeight={600}
                            theme="purple"
                          >
                            {caseDetails.dentist.user.email}
                          </StyledText>
                        </Grid>
                        {caseDetails.dentist.dateOfBirth && (
                          <>
                            <Grid item xs={6}>
                              <StyledText
                                display="inline"
                                fontSize={13}
                                fontWeight={400}
                                theme="purple"
                                style={{
                                  color: grey[700],
                                }}
                              >
                                Date of Birth
                              </StyledText>
                            </Grid>
                            <Grid item xs={6}>
                              <StyledText
                                display="inline"
                                fontSize={14}
                                fontWeight={600}
                                theme="purple"
                              >
                                {normalizeDateTime(
                                  caseDetails.dentist.dateOfBirth
                                )}
                              </StyledText>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </BannerInfo>
                  </>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </div>
      <EditDentistDialog
        open={isEditDentistOpen}
        onClose={handleEditDentistClose}
        onDentistUpdate={onDentistUpdate}
        isSubmittingDentist={isSubmittingDentist}
      />
    </StyledBanner>
  );
};

export default CaseDetailsDashboard;
